export const meta: BlockMeta = {
  title: "Explore",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { TextImageThemeTile } from "@components/atoms/TextImageThemeTile"
import { Button } from "@components/ui/Button"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/explore", (props) => {
  return (
    <TextImageThemeTile theme={props.themeall || "yellow"} image={props.image || undefined}>
      <div className="w-full flex flex-col gap-7">
        <div className="w-full flex flex-col gap-4">
          <EditableText
            className="type-title-s pr-8"
            as="h2"
            store="title"
            defaultValue="Explore films and events and secure your ticket"
            placeholder="Example title"
            plainText
          />
          <EditableText
            store="subtitle"
            as="p"
            className="type-body-s"
            defaultValue="Visit our membership page to discover options for discounted tickets, presales, exclusive events and much more"
            placeholder="Example subtitle"
            plainText
          />
        </div>
        <div className="w-full flex flex-col gap-2 [&_button]:my-0 [&_button]:!w-full [&_button]:!justify-start">
          <InnerBlocks
            allowedBlocks={["content/button"]}
            orientation="vertical"
            adminClassName="w-full flex flex-col gap-2"
            template={[
              ["content/button", {}],
              ["content/button", {}],
              ["content/button", {}],
              ["content/button", {}],
            ]}
          />
        </div>
      </div>
    </TextImageThemeTile>
  )
})
